module.exports = __webpack_public_path__ + "static/media/twitter-logo.cae41723.svg";